export enum SettingsPageSections {
  PROFILE = 'profile',
  TEAM = 'team',
  WORKSPACE_SETTINGS = 'workspace_settings',
  API_KEYS = 'provider_api_keys',
  WEAVE_API_KEYS = 'api_keys',
  MODEL_MANAGEMENT = 'model_management',
  FONTS = 'fonts',
  BILLING = 'billing',
}
